import {
  faList,
  faThLarge,
  faArrowDown,
  faArrowUp,
  faSearch,
  faFolderOpen,
  faBook,
  faXmarkCircle,
  faFilter,
  faCartShopping,
  faHeart,
  faTrash,
  faFilm,
  faChalkboardUser,
  faEye,
  faMoneyCheck,
  faTimes,
  faCheck,
  faEdit,
  faUser,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { pubPath } from 'helpers/AppHelper';

export const MULTI_MODE = true;
export const TEST_VIDEO = false;
export const TEST_IMAGE = false;
export const TEST_REACT_18 = true;
export const WITH_SOUND = false;

export const REFRESH_HOME = false;
export const REFRESH_FILTER = true;
export const SERVER_DEMO = "demo";
export const SERVER_DEV = "dev";
export const CLIP_PATH = "/clip";
export const WORK_PATH = "/work";
export const ITEM_PATH = "/item";
export const OBJECT_PATH = "/object";
export const COLLECTION_PATH = "/collection"
export const WORKDETAILS_PATH = "/workdetails";
export const ITEMDETAILS_PATH = "/itemdetails";
export const OBJECTDETAILS_PATH = "/objectdetails";
export const COLLECTION = "collection";
export const PATH_START = "sdk";
export const STATION = "station1";
export const APP_NAME = "fernseharchiv-";
export const SEARCH = "search";
export const USE_EXTRALANE = true;
export const LANE = "lane";
export const SUB_TRAILER = true;
export const ITEMS_PER_PAGE = 12;
export const LIMIT = 12;
export const SHOW_PAGES = 3;
export const GRID = "grid";
export const LIST = "list";
export const WORK_GRID = "work_grid";
export const WORK_LIST = "work_list";
export const SEARCH_LIST = "search_list";
export const SEARCH_FILTER = "search_filter";
export const WORK_FILTER = "work_filter";
export const SEARCH_SORT = "search_sort";
export const CAROUSEL_LEN = 4;
export const CAROUSEL_INTERVAL = 5000;
export const HOME = "home";
export const CAROUSEL = "carousel";
export const DETAIL = "detail";
export const ITEM_DETAIL = "item_detail";
export const SEARCH_FORM = "search_form";
export const SEARCH_PAGE = "search_page";
export const WORK_DETAIL = "work_detail";
export const WORK_DETAIL_LONG = "work_detail_long";
export const WORK = "work";
export const NONE = "none";
export const BLOCK = "block";
export const FLEX = "flex";
export const DEFAULT = "default";
export const EN = "en";
export const DE = "de";
export const DEMO_SERVER = "https://sdk.demo.flowcenter.de";
export const LOCAL_HOST = "http://localhost:3000";
export const ASC = "asc";
export const DESC = "desc";
export const IMG_HEIGHT = 1500;
export const IMG_WIDTH = 1500;
export const FULL_HEIGHT = 1920;
export const FULL_WIDTH = 1920;
export const CL_ACTIVE_CLASS = "clippage-listbtn-active";
export const BTN_ACTIVE = "mainpage-listbtn-active";
export const DEFAULT_SEARCH_FIELD = "title";
export const BACK = "back";
export const NEXT = "next";
export const OVERVIEW = "overview";
export const FORM = "form";
export const CATALOG = "catalog";
export const OBJECT = "object";
export const ITEM = "item";
export const CLIP = "clip";
export const ALL = "all";
export const TRAILER_STARTTIME = 5000;
export const DATEGROUP = "dategroup";
export const DROPDOWN = "dropdown";
export const LABEL = 'label';
export const DONE = 'done';
export const UPDATED = 'updated';
export const ERROR = 'error';
export const CHECK_TERM = ' - ';
export const AUTO_DROPDOWN = "auto_dropdown";

export const MODE_DARK = false;

export const TEST_CONTENT_1 = "Lorem Ipsum";
//SEARCH_BOX BEGIN
export const SEARCH_PARTS = [
  { name: "catalog", },
  { name: "form", withBtn: true },
]
export const DEFAULT_SEARCH_TYPE = 'contains';
//SEARCH_BOX END

//SIDEBAR BEGIN
export const CLIPS_LIMIT = 12;
export const SIDEBAR_NEXT = 1;
export const SIDEBAR_HEIGHT = 540;
export const LATEST_LIMIT = 12;
export const SIDEBAR_ITEMS = 3;
export const SIDEBAR_SVG_ITEMS = [
  {
    id: "slider_chevTop_icon",
    data: [
      { name: "focusable", value: "false" },
      { name: "role", value: "presentation" },
      { name: "aria-label", value: `slider top` },
    ],
  },
  {
    id: "slider_chevBottom_icon",
    data: [
      { name: "focusable", value: "false" },
      { name: "role", value: "presentation" },
      { name: "aria-label", value: `slider bottom` },
    ],
  },
];
//SIDEBAR END

export const FONTSIZE_TXT = 14;
export const FONTSIZE_H1 = 21;
export const FONTSIZE_H2 = 15;

export const MAIN_SDK_SITE = [
  {
    name: "webiste",
    intl: "home.main_sdk_site",
    link: "https://www.deutsche-kinemathek.de/",
  },
];

export const NAVIGATION_ITEMS = [
  {
    name: "ard",
    intl: "data.navigation.home",
    label: "Home",
    isImg: true,
    url: "logos/ard_logo.png",
  },
  {
    name: "dra",
    intl: "data.navigation.home",
    label: "Home",
    isImg: true,
    url: "logos/dra_logo.png",
  },
  {
    name: "zdf",
    intl: "data.navigation.home",
    label: "Home",
    isImg: true,
    url: "logos/zdf_logo.png",
  },
  {
    name: "orf",
    intl: "data.navigation.home",
    label: "Home",
    isImg: true,
    url: "logos/orf_logo.png",
  }
];

export const REGIERUNG_LOGO = "/logos/bundesregierung.png";
export const BKM_LOGO = "/logos/BKM-Logo.svg";
export const BKM_LINK = "https://www.kulturstaatsministerin.de/DE/startseite/startseite_node.html";
export const BKM_LOGO_LINK = "https://www.deutsche-kinemathek.de/sites/default/files/public/logos/BKM-Logo.svg";
export const IMPRESSUM = "https://www.deutsche-kinemathek.de/de/impressum";
export const DATA_PROTECTION = "https://www.deutsche-kinemathek.de/de/datenschutz";

export const FOOTER_ITEMS = [
  {
    name: "impressum",
    intl: "footer.impressum",
    link: IMPRESSUM,
  },
  {
    name: "dataprotection",
    intl: "footer.dataprotection",
    link: DATA_PROTECTION,
  },
  {
    name: "bkm",
    intl: "footer.bkm",
    isImg: true,
    url: `${pubPath()}${BKM_LOGO}`,
    link: BKM_LINK
  }
]

export const LANE_ACTIVE = "mainpage-active";
export const SEARCH_OBJ = {
  name: "freesearch", intl: "home.leftside.freesearch",
  onClick: "onFreeSearchClick", icon: faSearch
};

export const USE_INFO = { name: "useinfo", intl: "home.leftside.useinfo", icon: faBook };

export const HOME_LEFT_SIDE_ITEMS = [
  USE_INFO,
  { name: "lane1", intl: "home.leftside.lane1", icon: faFolderOpen, onClick: "onLaneClick" },
  { name: "lane2", intl: "home.leftside.lane2", icon: faFolderOpen, onClick: "onLaneClick" },
  { name: "lane3", intl: "home.leftside.lane3", icon: faFolderOpen, onClick: "onLaneClick" },
  { name: "lane4", intl: "home.leftside.lane4", icon: faFolderOpen, onClick: "onLaneClick" },
  { name: "lane5", intl: "home.leftside.lane5", icon: faFolderOpen, onClick: "onLaneClick" },
  SEARCH_OBJ,
];

export const HOME_HEADING = [
  {
    name: "home_heading_searchportal",
    intl: "home.heading.searchportal",
    html: "h1",
  },
  // { name: "home_heading_searchcompany", intl: "home.heading.searchcompany", html: "h1" }
];

export const LINK = "link";
export const PHONE = "phone";
export const EMAIL = "email";

export const HOME_SEARCH_DD_ITEMS = [
  { name: "all", intl: "home.search.dd.all", value: "all", active: true },
  { name: "title", intl: "home.search.dd.title", value: "title" },
  { name: "person", intl: "home.search.dd.person", value: "person" },
  { name: "subject", intl: "home.search.dd.subject", value: "subject" },
];

export const SEARCH_SORT_DD_ITEMS = [
  { name: "title_asc", intl: "home.search.dd.title_asc", value: "title_asc" },
  {
    name: "title_desc",
    intl: "home.search.dd.title_desc",
    value: "title_desc",
  },
];

export const SORT_ICON_BTNS = [
  { name: ASC, icon: faArrowUp },
  { name: DESC, icon: faArrowDown },
];

export const VIEW_ICON_BTNS = [
  { name: LIST, icon: faList, htmlClass: "ms-4" },
  { name: GRID, icon: faThLarge },
];

export const HOME_SLIDER_IMAGES = [
  { name: "img1", value: "01-queens-gambit-kinmathek.jpg" },
  { name: "img2", value: "02-totentanz-kinemathek.jpg" },
  { name: "img3", value: "03-gerhard-lamprecht-kinemathek.jpg" },
  { name: "img4", value: "04-ken-adam-kinemathek.jpg" },
  { name: "img5", value: "05-du-mich-auch-kinemathek.jpg" },
  { name: "img6", value: "06-marlene-dietrich-kinemathek.jpg" },
  { name: "img7", value: "07-fenneker-kinemathek.jpg" }
];

export const HOME_SEARCH_ITEMS = [
  { name: "title", intl: "home.search.title", type: "text" },
  { name: "regie", intl: "home.search.regie", type: "text" },
  { name: "production", intl: "home.search.production", type: "text" },
];

//VIDEO BEGIN
export const LOAD_LATER = true;
export const START_LOAD = 50;
export const SHOW_SUBTILE = true;
export const ENTER = "Enter";
export const AUTOPLAY = false;
export const VIDEO = "video";
export const AUDIO = "audio";
export const IMAGE = "image";
export const PICTURES = "pictures";
export const VOLUME_DEFAULT = 0.5; // Max = 1
export const VOLUME_WIDTH = 50; // 50%
export const VIDEO_LOUNGE = "Video Lounge";
export const AUDIO_LOUNGE = "Audio Lounge";
export const SERVER_INTERN = "intern";
export const SAMPLES = 10000;
export const AUDIO_LENGTH = 7000000;
export const BLACK = "#000000";
export const WAVE_COLOR = "#468E99";
export const PROGRESS_COLOR = "#0D5F7D";
export const COLOR_RED = "#d5001c";

export const TITLE_LEN = 110;
export const DES_LEN = 135;
export const TITLE_MAX = 500;
export const DES_MAX = 2000;
export const CATEGORY_TXT_MAX = 25;
export const CHECK_TIME = 2000;
export const INACTIVE = 900;
export const BOTTOM_SPACE = 60;
export const WAIT_TIME = 1000;
export const CHECK_CONN_TIME = 1000;
export const AUTO_TIME = 2000;

export const SUBTITLE_TEST = false;
export const SRT_SUBTITLE_TEST = false;
export const SHOWING = "showing";
export const HIDDEN = "hidden";
export const UI_TIMEOUT = 2000;
export const SOUNDWAVE_ID = "wavesurfer--soundwaveId";
export const IMG_SOUNDWAVE_ID = "img_soundwaveId";
export const SERVER_AUDIO_TEST = false;
export const NO_BLOB = true;
export const BTN = 'button';

export const SUBTITLES = [
  {
    name: "en",
    intl: "videoplayer.subtitle.en",
    src: "sdk_testsub_en_US.vtt",
    label: "en_US",
  },
  {
    name: "de",
    intl: "videoplayer.subtitle.de",
    src: "sdk_testsub_de_DE.vtt",
    label: "de_DE",
  },
];

export const SUBTITLES_SRT = [
  {
    name: "en",
    intl: "videoplayer.subtitle.en",
    src: "nlw_testsub_en_US.srt",
    label: "en_US",
  },
  {
    name: "de",
    intl: "videoplayer.subtitle.de",
    src: "nlw_testsub_de_DE.vtt",
    label: "de_DE",
  },
];

export const VIDEO_SPEED = [
  { option: ".25" },
  { option: ".5" },
  { option: ".75" },
  { option: "1", selected: true },
  { option: "1.25" },
  { option: "1.5" },
  { option: "1.75" },
  { option: "2" },
];
//VIDEO END

//CLIPDETAIL BEGIN
export const CLIPDETAIL_LEFTMENU = [
  { name: "back", intl: "clipdetail.leftmenu.back" },
  { name: "overview", intl: "clipdetail.leftmenu.overview" },
  { name: "next", intl: "clipdetail.leftmenu.next" },
];
//CLIPDETAIL END

//WORKDETAIL BEGIN
export const WORKDETAIL_LEFTMENU = [
  { name: "back", intl: "clipdetail.leftmenu.back" },
  { name: "overview", intl: "clipdetail.leftmenu.overview" },
  { name: "next", intl: "clipdetail.leftmenu.next" },
];
//WORKDETAIL END

//SDK FRONTEND

export const HOME_SEARCH = "Datenbanksuche";
export const HOME_TEXT = "Hier können Sie in einem Auszug aus der MDCB von rund 1.500 Datensätzen recherchieren. Wenn Sie sich für den gesamten Nachlass interessieren, kontaktieren Sie uns bitte.";
export const HOME_CONTACT = [
  { name: 'contact_collection', intl: 'home.contact.collection', html: 'p' },
  { name: 'contact_service', intl: 'home.contact.service', html: 'bold' },
  { name: 'contact_phone', intl: 'home.contact.phone', html: 'phone', value: '497144848425' },
  { name: 'contact_fax', intl: 'home.contact.fax', html: 'p' },
  { name: 'contact_email', intl: 'home.contact.email', value: 'auskhss@dla-marbach.de', html: 'link' },
  { name: 'contact_open', intl: 'home.contact.open', html: 'p' },
]

export const HOME_TXT1 = 'Vielen Dank für Ihr Interesse an unseren Beständen. An dieser Stelle haben Sie ' +
  'die Gelegenheit, selbständig in unseren Sammlungen und Archiven zu ' +
  'recherchieren. Sie können über alle Bereiche hinweg suchen oder Ihre Anfrage ' +
  'auf einzelne Bereiche – Filmarchiv oder filmbegleitende Sammlungen (Fotos, ' +
  'Plakate, Schriftgut, Textilien, 3D-Objekte, filmtechnische Geräte) – ' +
  'beschränken. Als Suchergebnis erhalten Sie Ergebnislisten mit Metadaten und ' +
  'Vorschaubildern, aber keinen Zugang zum Material selbst.'


export const HOME_TXT2 = 'Hier haben Sie die Möglichkeit, selbstständig in unseren Sammlungen und Archiven zu recherchieren. Sie erhalten eine Übersicht der Suchergebnisse und Vorschaubilder, aber keinen direkten Zugang zum Material. Sie können Ihre Suche auf einzelne Bereiche – Filmarchiv oder filmbegleitende Sammlungen (Schriftgut, Fotos, Plakate, Textilien) – beschränken. Wenn Sie Filme für eine Vorführung ausleihen möchten, grenzen Sie die Suche ein, indem Sie auf den Button »Nur Verleihfilm« klicken. Es werden Ihnen dann ausschließlich Filme aus unserem Verleih angezeigt.';

export const CLIPLIST_ICON_BTNS = [
  { name: LIST, icon: faList, htmlClass: 'ms-4' },
  { name: GRID, icon: faThLarge }
]

export const HOME_CONTENT_ITEMS = [
  {
    name: "section1",
    heading: "Hinweise zu unseren Beständen",
    texte: [
      { name: "txt1", value: HOME_TXT2 },
    ]
  },
  {
    name: "section2",
    subHeading: "mainpage.content.list.sec02.heading",
    listWithLink: [
      { name: "li01", intl: "mainpage.content.list.sec02.li.01" },
    ],
    listLinkTxt: "mainpage.content.list.sec02.li.link",
    //listLinkUrl: `https://www.deutsche-kinemathek.de/sites/default/files/public/Archive/Filmverleih/Filmverleih_Formular.pdf`,
    listLinkUrl: `${window.location.origin}/Filmverleih/Filmverleih_Formular.pdf`,
    listLinkAddTo: "mainpage.content.list.sec02.li.linkAddTo",
  },

  {
    name: "section3",
    listHeadingIntl: "mainpage.content.list.sec03.heading",
    list: [
      { name: "li01", intl: "mainpage.content.list.sec03.li.01" },
      { name: "li02", intl: "mainpage.content.list.sec03.li.02" },
      { name: "li03", intl: "mainpage.content.list.sec03.li.03" },
    ]
  },
  {
    name: "section4",
    texte: [
      { name: "txt1", intl: "mainpage.content.help" },
    ]
  },
  {
    name: "section4",
    texte: [
      {
        name: "txt1", intl: "mainpage.content.contact", html: "link",
        link: "https://www.deutsche-kinemathek.de/de/sammlungen-archive/unsere-archive#kontakte",
        type: "button"
      },
    ]
  },
]

//export const RENTALOBJ = { field: 'collection', type: DEFAULT_SEARCH_TYPE, value: 'verleih', itemFilter: { field: 'txt3', value: 'VERLEIH' } };
//RENTALOBJ => will be changed in RENTAL_CHANGED_DATA
export const RENTALOBJ = { field: 'collection', type: DEFAULT_SEARCH_TYPE, value: 'verleih' };
// export const RENTAL_ITEMFILTER_OBJ = { field: 'itcopyusage', value: '3' };
export const RENTAL_ITEMFILTER_OBJ = { field: 'itcopyusage', value: '6;7' };

export const RENTAL_CHANGED_DATA = [
  { field: "", type: "BEGIN_OR", value: "" },
  { field: "copy_usage", type: "contains", value: "6" },
  { field: "copy_usage", type: "contains", value: "7" },
  { field: "", type: "END_OR", value: "" }
];

export const TAB_WORK = "tab_work";
export const TAB_OBJ = "tab_obj";
export const TAB_ITEM = "tab_item";
export const PART_WORK = "part_work";
export const PART_OBJ = "part_obj";
export const PART_ITEM = "part_item";

export const TAB_OBJ_ITEM = {
  name: TAB_OBJ, intl: "searchfilter.tab_obj",
  part: PART_OBJ,
  configName: OBJECT, checkDisplay: true
};

export const SEARCHFILTER_TABS = [
  { name: TAB_WORK, intl: "searchfilter.tab_work", active: true, part: PART_WORK, configName: WORK },
  TAB_OBJ_ITEM
]

export const WORKFILTER_TABS = [
  { name: TAB_ITEM, intl: "workfilter.tab_item", active: true, part: PART_ITEM, configName: ITEM },
  { name: TAB_OBJ, intl: "workfilter.tab_obj", part: PART_OBJ, configName: OBJECT, checkDisplay: true }
]

export const SEARCHFILTER_ACTIONS = [
  { name: "usefilter", intl: "searchfilter.button.usefilter", icon: faFilter, onClick: "onUseFilter" },
  { name: "resetfilter", intl: "searchfilter.button.resetfilter", icon: faXmarkCircle, onClick: "onResetFilter" }
]

export const WORKFILTER_ACTIONS = [
  { name: "usefilter", intl: "workfilter.button.usefilter", icon: faFilter, onClick: "onUseFilter" },
  { name: "resetfilter", intl: "workfilter.button.resetfilter", icon: faXmarkCircle, onClick: "onResetFilter" }
]

export const MAX_LENGTH = 60;
export const FIRST = 'first';
export const SECOND = 'second';
export const THIRD = 'third';
export const DEFAULT_IMG = 'img1.jpg';


//LANGUAGE
export const SHOW_LANG = false;
// AUTH BEGIN
export const SHOW_AUTH = false;
export const SHOW_CART = false;
export const AUTH_EXPIRATION = 4; // Difference 2 Hours => 2 Hours

export const REGISTER = "register";
export const REGISTER_USER = "register_user";
export const REGISTER_INST = "register_inst";
export const REGISTER_INST_DIFF_INVOICE_ADDR = "register_inst_different_invoice_address";
export const REGISTER_INST_DIFF_DELIVERY_ADDR = "register_inst_different_delivery_address";
export const REGISTER_USER_DIFF_INVOICE_ADDR = "register_user_different_invoice_address";
export const REGISTER_USER_DIFF_DELIVERY_ADDR = "register_user_different_delivery_address";
export const REGISTER_OVERVIEW = "register_overview";
export const REGISTER_NEW_INST = "register_new_inst";
export const REGISTER_CREATE_INST = "register_create_inst";
export const REGISTER_APPLY = 'register_apply';
export const REGISTER_CHECK = "register_check";
export const FILL_USER = "fill_user";
export const LOGIN = "login";
export const ACCEPT = "accept";
export const EMPTY = 'empty';
export const EXPIRED = 'expired';
export const BREAKLINE = 'breakline';
export const TEXT = 'text';
export const INPUT = 'input';
export const COLLAPSE = 'collapse';
export const TEXT_FROM_CHILDREN = 'text_from_children';
export const READONLY = 'readonly';
export const NOT_SEND = 'not_send';
export const CHECKBOX = 'checkbox';
export const SPLIT = 'split';
export const INFO = 'info';
export const SUB_MAILINGS = "subscribe_mailings";
export const LIST_DATA = "listdata";
export const LINK_DATA = "linkdata";
export const PASSWORD = 'password';
export const MAILEXISTS = 'mailexists';
export const MAIL_OK = 'userdata ok';
export const XX = 'XXXXXX';
export const ADD_TWO_HOURS = 2 * 60 * 60 * 1000;
export const USER_INST = 'u_instid';
export const ID = 'id';
export const INST_DATA = 'Name';
export const FILL_SAVE = 'fill_save';
export const FILL_CANCEL = 'fill_cancel';
export const ONLY_REPEAT = 'onlyRepeat_';
export const NOT_MATCHED = `Die Passwörter stimmen nicht überein. Bitte prüfen Sie Ihre Eingabe.`;
export const INVALID_PW = `Die Passwörter stimmen nicht überein. Bitte prüfen Sie Ihre Eingabe.Das Passwort muss aus mindestens 8 Zeichen mit Groß- und Kleinbuchstaben und Zahlen bestehen.`;

export const LOGIN_ITEMS = [
  { name: 'username', intl: "data.auth.email", required: true, type: "input", hiddenStar: true },
  { name: 'password', intl: "data.auth.password", required: true, type: "password", hiddenStar: true, notVertify: true },
]

export const ACCEPT_ITEMS = [
  { name: "txt1", intl: "data.auth.accepttext.01" },
  { name: "txt2", intl: "data.auth.accepttext.02" },
  { name: "txt3", intl: "data.auth.accepttext.03" },
];

export const REGISTER_ACTIONS = [
  { name: "back", intl: "data.auth.back", type: "button" },
  { name: "next", intl: "data.auth.next", type: "button" }
];

export const FILL_ACTIONS = [
  { name: FILL_CANCEL, intl: "data.auth.cancel", type: "button", action: FILL_SAVE },
  { name: FILL_SAVE, intl: "data.auth.save", type: "button", action: FILL_CANCEL }
]


export const REGISTER_CREATE_ACTIONS = [
  { name: "back", intl: "data.auth.cancel", type: "button" },
  { name: "next", intl: "data.auth.ok", type: "button" }
]

export const REGISTER_OVERVIEW_ACTIONS = [
  { name: "back", intl: "data.auth.back", type: "button" },
  { name: REGISTER_APPLY, intl: "data.auth.apply", type: "button", isLarge: true }
]

//AUTH CUSTOMCONFIG BEGIN
export const ACCEPT_PROTECTION_DATA = [
  { name: 'breakline', type: BREAKLINE, noLine: true, displayOrder: 3 },
  {
    name: 'data_protection', field: 'data_protection', intl: "data.auth.data_protections.txt01",
    type: "checkbox", displayType: "linkdata", displayIntl: "data.auth.apply.data_protections",
    txtWithLink: "data.auth.data_protections.txt02",
    txtLinkUrl: "https://www.deutsche-kinemathek.de/de/sammlungen-archive/bibliothek/benutzungsordnung-datenschutz",
    txtLinkAddTo: "data.auth.data_protections.txt03",
    required: true, cbLeft: true, displayOrder: 4,
  },
  {
    name: 'terms_of_use', field: 'terms_of_use', intl: "data.auth.termsofuse.txt01",
    type: "checkbox", displayType: "linkdata", displayIntl: "data.auth.apply.termofuse",
    txtWithLink: "data.auth.termsofuse.txt02",
    txtLinkUrl: "https://www.deutsche-kinemathek.de/de/sammlungen-archive/bibliothek/benutzungsordnung-datenschutz",
    required: true, cbLeft: true, displayOrder: 5,
  },
  {
    name: 'confirm_order', field: 'confirm_order', intl: "data.auth.confirm_order", displayOrder: 2,
    type: "checkbox", displayType: LIST_DATA, displayIntl: "data.auth.apply.confirm_oder", required: true, cbLeft: true
  },
  {
    name: 'prefer_english', field: 'prefer_english', intl: "data.auth.prefer_english", displayOrder: 1,
    type: "checkbox", displayType: LIST_DATA, displayIntl: "data.auth.apply.prefer_english", cbLeft: true
  },
];

export const NEW_INSTITUTION_BTN = {
  name: 'newinstitution', intl: "data.auth.newinstitution", type: "button", noBuff: true, htmlClass: "registerform-xl-box",
  authForm: REGISTER_CREATE_INST
};

export const INSTITUTION_BUTTONS = [
  {
    name: "institution_buttons", type: "collapse", children: [
      {
        name: 'diffinvoicegaddress', type: 'button', intl: "data.auth.diffinvoiceaddr",
        authForm: REGISTER_INST_DIFF_INVOICE_ADDR, order: 11,
      },
      {
        name: 'diffdeliveryaddress', type: 'button', intl: "data.auth.diffdeliveryaddr",
        authForm: REGISTER_INST_DIFF_DELIVERY_ADDR, order: 12,
      },
    ]
  }
];

export const USER_BUTTONS = [
  {
    name: "user_buttons", type: "collapse", children: [
      {
        name: 'diffinvoicegaddress', type: 'button', intl: "data.auth.diffinvoiceaddr",
        authForm: REGISTER_USER_DIFF_INVOICE_ADDR, order: 20
      },
      {
        name: 'diffdeliveryaddress', type: 'button', intl: "data.auth.diffdeliveryaddr",
        authForm: REGISTER_USER_DIFF_DELIVERY_ADDR, order: 21
      },
    ]
  }
];

export const RED_BREAKLINE = { name: 'breakline', type: BREAKLINE, order: 13 };
export const BREAKLINE_OBJ = { name: 'breakline', type: BREAKLINE, noLine: true };

export const INST_DIFF_DELIVERY_ADD_OBJ = { name: "inst_diff_delivery_addr", type: "info", intl: "data.auth.diff_delivery_addr" };
export const INST_DIFF_INVOICE_ADD_OBJ = { name: "inst_diff_invoice_addr", type: "info", intl: "data.auth.diff_invoice_addr" };

export const USER_DIFF_DELIVERY_ADD_OBJ = { name: "user_diff_delivery_addr", type: "info", intl: "data.auth.diff_delivery_addr" };
export const USER_DIFF_INVOICE_ADD_OBJ = { name: "user_diff_invoice_addr", type: "info", intl: "data.auth.diff_invoice_addr" };

export const APPLY_INFO_OBJ = { name: "applyinfo", intl: "data.register.apply", type: "info", htmlClasses: 'registerform-longtxt' };

export const INST_PERMISSION_OBJ = { name: "instpermission", intl: "data.register.instpermission", type: "checkbox", required: true, htmlClasses: "uicb-l-container" };
export const BREAKLINE_RED_OBJ = { name: 'breakline', type: BREAKLINE };

export const INST_MEMBER_FIAF_OBJ = { name: "instmemberfiaf", intl: "data.register.instmemberfiaf", type: "checkbox", htmlClasses: "uicb-xl-container" };

//AUTH CUSTOMERCONFIG END


//WISHLIST AND CART BEGIN
export const CART = "cart";
export const CART_MAINPAGE = "cart_mainpage";
export const WISHLIST = "wishlist";
export const CARTLIST = "cartlist";
export const CART_REQUEST = "cart_request";
export const CARTREQUEST_LIST = "cartrequest_itemslist";
export const CARTREQUEST_TABLE = "cartrequest_itemstable";
export const CARTREQUEST_USERDETAILS = 'cartrequest_userdetails';
export const CARTREQUEST_DELIVERY = 'cartrequest_delivery';
export const CARTREQUEST_INVOICE = 'cartrequest_invoice';
export const CARTREQUEST_PRICES = 'cartrequest_prices';
export const RENT_EDIT = "rentedit";
export const INDEX = 'index';
export const COMBINE = 'combine';
export const ITEMS_CARTLIST = "itemsCartList";
export const SHOWDATES = 'showdates';
export const SHOWS = 'shows';
export const ADD_TO_CART = "add_to_cart";
export const DELETE = "delete";
export const CALENDAR = "calendar";
export const ADD_WORKS = "add_works";
export const PROCESS = "PROCESS";
export const BUTTON = "button";
export const EDIT = "edit";
export const COMPLEX = "complex";
export const CART_REQUEST_ACTION = "cart_request_action";
export const ONLY_CART = "onlyForCart";
export const EDITLIST = 'editlist'
export const WISHLIST_WORKTOITEM = "wishlist_workToItem";
export const CARTLIST_WORKTOITEM = "cartlist_workToItem";
export const CALENDAR_OBJ = { name: "calendar", type: "calendar" };
export const SHOWDATES_OBJ = { name: "showdates", type: EDITLIST, intl: 'cart.showdates' };
export const DATES = "dates";
export const INVOICE = "invoice";
export const OWNER_INST = "owner_inst";
export const ITEM_COUNT = "item_count";
export const ITEM_INFO = "item_info";
export const WORK_INFO = "work_info";
export const DEFAULT_LINE_HEIGHT = 20;
export const DEFAULT_ITEM_LINES = 6;
export const DEFAULT_PRICE = 50;
export const DEFAULT_COUNT = 1;
export const DEFAULT_SHIPPING = 2;
export const IS_REDUCED = "isReduced";
export const CART_EMPTY = "cart_empty";
export const CALENDAR_SHOW = "calendar_show";
export const WISHLIST_EMPTY = "wishlist_empty";
export const RENTALLIST = "rentallist";
export const RENTALLIST_EMPTY = "rentallist_empty";
export const MESSAGE_OBJ = {
  cart_empty: { intl: "cartmessage.cart_empty", icon: faCartShopping, title: "cartmessage.cart" },
  wishlist_empty: { intl: "cartmessage.wishlist_empty", icon: faHeart, title: "cartmessage.wishlist" },
  rentallist_empty: { intl: "cartmessage.rentallist_empty", icon: faChalkboardUser, title: "cartmessage.rentallist" }
}

export const NAV_CART_TABS = [
  { name: "nav_wishlist", intl: "data.nav.wishlist", icon: faHeart, onClick: "onWishList", mode: "wishlist" },
  { name: "nav_cart", intl: "data.nav.cart", icon: faCartShopping, onClick: "onCartClick", mode: "cart" },
  // { name: "nav_rentallist", intl: "data.nav.rentlist", icon: faList, onClick: "onRentalList", mode: "rentallist" },
  // { name: "nav_profile", icon: faChalkboardUser, onClick: "onProfile", mode: "profile", htmlClasses: "navigation-xs" }
]

export const WISHLIST_ITEMS_ACTIONS = [
  { ...CALENDAR_OBJ, isCartSymbol: true },
  //{ name: "addtocart", icon: faCartShopping, action: ADD_TO_CART },
  { name: "delete", icon: faTrash, action: "delete" }
];

export const WORKLIST_ITEMS_ACTIONS = [
  { name: "delete", icon: faTrash, action: "delete" }
];

export const CARTLIST_ITEMS_ACTIONS = [
  { name: "delete", icon: faTrash, action: "delete" }
];

export const RENTALLIST_ITEMS_ACTIONS = [
  { name: "edit", icon: faEdit, action: "edit", intl: "rentalist.edit", htmlClasses: "listitem-btn" }
];

export const CARTREQUEST_HEADLINEDATA = [
  { name: 'request', intl: 'cartrequest.request', type: 'label', htmlClasses: "cartrequest-bold" },
  { name: 'processnumber', intl: 'cartrequest.processnr' },
  {
    name: 'pricegroup', intl: 'cartrequest.pricegroup', type: 'dropdown', field: 'pricegroup', data: [
      { name: 'domestic_show', intl: 'cartrequest.domestic_show' },
      { name: 'small_community_cinema', intl: 'cartrequest.small_community_cinema' },
      { name: 'abroad_festivals', intl: 'cartrequest.abroad_festivals' },
      { name: 'scientific_use', intl: 'cartrequest.scientific_use' }
    ]
  }
];

export const CARTREQUEST_SUBHEADLINEDATA = [
  { name: 'request', intl: 'cartrequest.yourselection', type: 'info', htmlClasses: "cartrequest-bold-ms" },
  { name: 'breakline', type: BREAKLINE }
]

export const CARTREQUEST_ADDDATA = [
  { name: "showdates", intl: "cartrequest.showdates", fields: 'showdates', type: 'showdates', htmlClasses: "cartrequest-active" },
  { name: "shows", intl: "cartrequest.shows", fields: 'shows', type: 'shows', htmlClasses: "cartrequest-active" },
];

export const SEND_REQUEST = 'sendrequest';
export const CARTREQUEST_ACTIONS = [
  { name: SEND_REQUEST, intl: "cartrequest.send", type: "button", onClick: "onSendRequestClick" },
];

export const CARTREQUEST_CHANGE_DELIVERY_ADDRESS = [
  { name: "changeDeliveryAddress", intl: "cartrequest.changeDeliveryAddress", type: "button", onClick: "onDeliverAddClick" },
];

export const CARTREQUEST_CHANGE_INVOICE_ADDRESS = [
  { name: "changeInvoiceAddress", intl: "cartrequest.changeInvoiceAddress", type: "button", onClick: "onInvoiceAddClick" },
];

export const CARTREQUEST_TOTAL = 'cartrequest_total';

export const CARTREQUEST_TOTALDATA = [
  {
    "name": "Prices",
    "intl": "ecommerce.prices",
    "field": "prices",
    data: [
      { name: 'total', intl: "cartrequest.sdk_total", field: 'total', htmlClasses: 'cartselectlist-complex' },
      { name: 'tax', intl: "cartrequest.sdk_tax", field: 'tax', htmlClasses: "cartselectlist-complex cartselectlist-bold-xs" }
    ],
    "type": "complex"
  }
];

export const CARTREQUEST_SOURCES = [
  { name: 'rental_sdk', intl: "cartrequest.rental_sdk", field: 'source', isShow: true },
  { name: 'rental_defa', intl: "cartrequest.rental_defa", field: 'source' },
];

export const CARTREQUEST_TRANSPORTDATA = [
  { name: 'transport_analog', intl: "cartrequest.transport_analog", checkField: 'txt4' },
  { name: 'transport_digital', intl: "cartrequest.transport_digital", checkField: 'txt4' }
];

export const CARTREQUEST_ANALOG_ACTIONS = [
  { name: "selftransport", intl: "cartrequest.selftransport", field: 'selftransport', type: 'checkbox', show: true },
];

export const CARTREQUEST_ANALOG_TOTAL = [
  { name: "analog_total", intl: "cartrequest.analog_total", field: 'analog_total', type: 'text', show: true },
  { name: "analog_tax", intl: "cartrequest.analog_tax", field: 'analog_tax', type: 'text', show: true },
];

export const CARTREQUEST_DIGITAL_ACTIONS = [
  {
    name: "edelivery", intl: "cartrequest.edelivery", field: 'edelivery', type: 'dropdown', show: true,
    data: [
      { name: 'hdd_versand', intl: 'cartrequest.hdd' },
      { name: 'edelivery', intl: 'cartrequest.eDelivery' }
    ]
  },
];

export const CARTREQUEST_TRANSPORT_TYPES = [
  { name: 'canscount', intl: "cartrequest.canscount" },
  { name: 'transporttype', intl: "cartrequest.transporttype" }
]

export const CARTREQUEST_ADVANCEDDATA = [
  { name: "preisgruppe2", intl: "cartrequest.preisgruppe2", field: 'preisgruppe2', type: 'checkbox', show: true },
  { name: "wissenschaft", intl: "cartrequest.wissenschaft", field: 'wissenschaft', type: 'checkbox', show: true },
  { name: "selftransport", intl: "cartrequest.selftransport", field: 'selftransport', type: 'checkbox', show: true },
  {
    name: "edelivery", intl: "cartrequest.edelivery", field: 'edelivery', type: 'dropdown', show: true,
    data: [
      { name: 'hdd_versand', intl: 'cartrequest.hdd' },
      { name: 'edelivery', intl: 'cartrequest.eDelivery' }
    ]
  },
];

export const CARTLIST_FOOTER = [
  { name: "add_works", intl: "cartlist.addworks", icon: faFilm, action: ADD_WORKS },
  { name: "process_request", intl: "cartlist.processrequest", icon: faMoneyCheck, action: CART_REQUEST_ACTION },
];
//export const CARTREQUEST_CLERK = `Angebot vom xx.xx.xxxx - gültig bis xx.xx.xxxx (Sachbearbeiter Deutsche Kinemathek: Anke Hahn)`;
export const DEFAULT_CLERK = 'Anke Hahn';
export const CARTREQUEST_CLERK = [
  { name: "offer_from", intl: "cartrequest.offer", intl_bold: "cartrequest.from", isBold: true },
  { name: "offer_to", intl_bold: "cartrequest.offer_to", isBold: true },
  { name: "offer_clerk", intl: "cartrequest.offer_clerk", isBracket: true }
];

export const ACCEPT_OFFER = "accept_offer";
export const DENY_OFFER = "deny_offer";

export const RENTAL_LIST = [
  { name: "status", intl: "rentallist.status", field: "status", createStatus: true, order: 1 },
  {
    name: "process_nr", intl: "rentallist.process_nr", field: "process_id",
    createUnique: true, order: 2, htmlClasses: "listitem-item-center"
  },
  // { name: "title", intl: "rentallist.title" }, //getMetadataConfig
  { name: "from", intl: "rentallist.from", field: "screeningStart", order: 4 },
  { name: "to", intl: "rentallist.to", field: "screeningEnd", order: 5 },
  {
    name: "count", intl: "rentallist.count", field: "itemsCount",
    order: 6, htmlClasses: "listitem-item-center"
  },
];

export const RENTAL_STATUS = [
  { name: "request", value: "Anfrage", htmlClasses: "listitem-item-yellow" },
  { name: "offer", value: "Angebot", htmlClasses: "listitem-item-orange" },
  { name: "done", value: "Abgeschlossen", htmlClasses: "listitem-item-green" }
];
//WISHLIST AND CART END

// PROFILE
export const PROFILE_EDIT = 'profile_edit';
export const PROFILE_USER = 'profile_user';
export const PROFILE_SAVE = 'save';
export const PROFILE_USER_DIFF_INVOICE_ADDR = "profile_user_different_invoice_address";
export const PROFILE_USER_DIFF_DELIVERY_ADDR = "profile_user_different_delivery_address";
export const NOT_LOGGED_IN = 'not logged in';
export const COULD_NOT_REMOVE = 'could not remove element';
export const USER_UPDATED = 'user updated';
export const ADDED_TO_CART = 'added to cart';
export const PROFILE_ACTIONS = [
  { name: "cancel", intl: "profile.user.cancel", type: "button", icon: faTimes },
  { name: PROFILE_SAVE, intl: "profile.user.save", type: "button", loader: true, icon: faCheck }
];
export const PROFILE_TABS = [
  { name: PROFILE_USER, intl: "profile.user" }
];
export const PROFILE_USER_BUTTONS = [
  {
    name: "profile_user_buttons", type: "collapse", children: [
      {
        name: 'profile_diffinvoicegaddress', type: 'button', intl: "profile.diffinvoiceaddr",
        screenMode: PROFILE_USER_DIFF_INVOICE_ADDR, order: 20
      },
      {
        name: 'Profile_diffdeliveryaddress', type: 'button', intl: "profile.diffdeliveryaddr",
        screenMode: PROFILE_USER_DIFF_DELIVERY_ADDR, order: 21
      },
    ]
  }
];

//VIDEO PLAYER 
export const SPEED_ITEMS = [
  { name: '2x', value: '2', intl: '2x' },
  { name: '1.5x', value: '1.5', intl: '1.5x' },
  { name: 'Normal', value: '1', intl: 'Normal', htmlClass: 'tvactive-option' },
  { name: '0.75x', value: '0.75', intl: '0.75x' },
  { name: '0.5x', value: '0.5', intl: '0.5x' },
];

export const PLAYER_INTERVAL_TIME = 10;

export const MAIL_NOT_FOUND = 'mailnotfound';
export const SENDING_RESET_MAIL = 'sendingresetmail';

export const SOMETHING_WENT_WRONG = 'somethingwentwrong';

//name: "nav_profile", icon: faChalkboardUser, onClick: "onProfile", mode: "profile", htmlClasses: "navigation-xs"
export const USERPROFILE_ITEMS = [
  { name: 'profile', intl: 'profile.userprofile', icon: faChalkboardUser, onClick: "onProfile" },
  { name: 'logout', intl: 'profile.logout', icon: faSignOutAlt, onClick: "onLogOut" }
];

export const INPUT_DEPENDS_ON_DD = 'inputDependsOnDD';
export const INPUT_DEPENDS_ON_DD_READONLY = 'inputDependsOnDD_readonly';


